import { render, staticRenderFns } from "./customNav.vue?vue&type=template&id=7022a9d6&scoped=true&"
import script from "./customNav.vue?vue&type=script&lang=js&"
export * from "./customNav.vue?vue&type=script&lang=js&"
import style0 from "./customNav.vue?vue&type=style&index=0&id=7022a9d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7022a9d6",
  null
  
)

export default component.exports